var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Risorsa non trovata")]),_c('router-link',{staticClass:"nav-item",attrs:{"to":"/","tag":"a"}},[_c('a',[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }